import { render, staticRenderFns } from "./EditComment.vue?vue&type=template&id=07689fb3&scoped=true&"
import script from "./EditComment.vue?vue&type=script&lang=js&"
export * from "./EditComment.vue?vue&type=script&lang=js&"
import style0 from "./EditComment.vue?vue&type=style&index=0&id=07689fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07689fb3",
  null
  
)

component.options.__file = "EditComment.vue"
export default component.exports